import { Component, h, Prop } from '@stencil/core';
import { ArticleLocation } from '../../rtr-article-details/utils/types';
import mapboxGL from 'mapbox-gl';
import { t } from '../../../redux/utils';

const mapBoxAccessToken = 'pk.eyJ1IjoiZ29lcmFuc2Nod2luZCIsImEiOiJjbWV1NXphZW0wM2wwMmtzNGZnZGtpeXkxIn0.tw5MRBfrTgSgdM7N-R95xA';

@Component({
  tag: 'rtr-location',
  styleUrl: 'style.sass',
  shadow: false,
})
export class RtrLocation {
  @Prop() location!: ArticleLocation;
  @Prop() customText: string;

  container: HTMLDivElement;

  componentDidLoad() {
    const coordinates = [this.location.longitude, this.location.latitude];
    const map = new mapboxGL.Map({
      container: this.container,
      center: coordinates,
      style: 'mapbox://styles/mapbox/streets-v12',
      interactive: true,
      attributionControl: false,
      zoom: 12,
      accessToken: mapBoxAccessToken,
    });

    const markerContainer = document.createElement('div');
    const marker = document.createElement('div');
    markerContainer.appendChild(marker);

    markerContainer.className = 'RLMarkerContainer';
    marker.className = 'RLMarker';

    new mapboxGL.Marker(markerContainer).setLngLat(coordinates).addTo(map);
    map.resize();
  }

  get locationText() {
    return t('details.location');
  }

  get address(): string {
    let address = '';

    if (this.location.street) {
      address += this.location.street.trim();
    }

    if (this.location.houseNumber) {
      address += ' ' + this.location.houseNumber.trim();
    }

    if (address !== '') {
      address += ', ';
    }

    if (this.location.zipCode) {
      address += this.location.zipCode.trim() + ' ';
    }

    if (this.location.city) {
      address += this.location.city.trim();
    }

    return address.trim();
  }

  render() {
    if (!this.location?.id) {
      return null
    }

    return (
      <div class="RLocation">
        <rentware-spacer size="S" />
        <span class="RLName">{this.locationText}</span>
        <rentware-spacer size="S" />
        {this.customText}
        <span class="RLAddress">{this.address}</span>
        <rentware-spacer size="M" />
        <div class="RLMap" id={this.location.id} ref={el => (this.container = el)} />
      </div>
    );
  }
}
